import axios from 'axios'

export const AUTHS = {
  NAME: 'auth',
  NAMESPACE: (name) => `auth/${name}`,
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  IS_LOGGED_IN: 'IS_LOGGED_IN',
  SET_CURRENT_USER: 'SET_CURRENT_USER',
  GET_CURRENT_USER: 'GET_CURRENT_USER',
  VALIDATE: 'VALIDATE',
}

const CUR_USER = 'auth.currentUser'

export const state = {
  currentUser: getSavedState(CUR_USER),
}

export const mutations = {
  [AUTHS.SET_CURRENT_USER](state, newValue) {
    state.currentUser = newValue
    saveState(CUR_USER, newValue)
    // setDefaultAuthHeaders(state)
  },
}

export const getters = {
  [AUTHS.IS_LOGGED_IN](state) {
    return !!state.currentUser
  },
  [AUTHS.GET_CURRENT_USER](state) {
    return state.currentUser
  },
}

export const actions = {
  // This is automatically run in `src/state/store.js` when the app
  // starts, along with any other actions named `init` in other modules.
  init({ state, dispatch }) {
    // setDefaultAuthHeaders(state)
    // dispatch('validate')
  },

  // Logs in the current user.
  [AUTHS.LOGIN]({ commit, dispatch, getters }, { username, age, gender } = {}) {
    // if (getters[AUTHS.GET_CURRENT_USER]) return dispatch('validate')
    commit(AUTHS.SET_CURRENT_USER, { username, age, gender })
    return Promise.resolve()
    // return axios.post('/api/session', { username, gender }).then((response) => {
    //   const user = response.data
    //   commit(AUTHS.SET_CURRENT_USER, user)
    //   return user
    // })
  },

  // Logs out the current user.
  [AUTHS.LOGOUT]({ commit }) {
    commit(AUTHS.SET_CURRENT_USER, null)
  },

  // Validates the current user's token and refreshes it
  // with new data from the API.
  // validate({ commit, state }) {
  //   if (!state.currentUser) return Promise.resolve(null)
  //
  //   return axios
  //     .get('/api/session')
  //     .then((response) => {
  //       const user = response.data
  //       commit(AUTHS.SET_CURRENT_USER, user)
  //       return user
  //     })
  //     .catch((error) => {
  //       if (error.response && error.response.status === 401) {
  //         commit(AUTHS.SET_CURRENT_USER, null)
  //       } else {
  //         console.warn(error)
  //       }
  //       return null
  //     })
  // },
}

// ===
// Private helpers
// ===

function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

function saveState(key, state) {
  window.localStorage.setItem(key, state ? JSON.stringify(state) : null)
}

function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.currentUser ? state.currentUser.token : ''
}
